import { Injectable } from '@angular/core';
import { BrowserCheckService } from '../browser-check.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private readonly browserCheck: BrowserCheckService) {}

  getToken(): string {
    return this.browserCheck.getSessionStorage('accessToken') ?? '';
  }

  setToken(token: string): void {
    this.browserCheck.setSessionStorage('accessToken', token);
  }
}
